import { Grid, Typography } from "@mui/material";

import overviewGraphic from "./images/overviewGraphicVjustC.jpg";
import InfoTitle from "./InfoTitle";

export default function VjustCostOverview({ classes }) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <InfoTitle title="VJuST Background" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={classes.bodyText}>
          The Federal Highway Administration (FHWA) Office of Operations
          Research and Development developed the Capacity Analysis for Planning
          of Junctions (CAP-X) software to screen innovative intersection and
          interchange configurations. In 2016, the Virginia Department of
          Transportation (VDOT) altered the CAP-X software for use in
          determining the congestion component in the SMART SCALE application
          scoring process. The altered software was renamed to the VDOT Junction
          Screening Tool (VJuST) and includes 26 unique intersection and
          interchange configurations.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <img
          alt={
            "Overview of VJuST-C showing that there are 4 phases of intersection planning and design: Screening Level, Concept Desing, Final Design, and Construction. VJuST-C is used at the Screening Level, meaning it is not as detailed as the other phases."
          }
          src={overviewGraphic}
          style={{ maxWidth: "1100px", width: "calc(100% - 50px)" }}
        />
      </Grid>
      <Grid item xs={12}>
        <InfoTitle title="VJuST-C Background" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={classes.bodyText}>
          After the implementation of VJuST, a need arose to understand cost
          differences between intersection and interchange forms. In 2019, a
          VJuST cost estimate module (VJuST-C) was developed as a companion to
          VJuST. VJuST-C provides planning-level cost estimates for the same
          intersection and interchange types. These cost estimates provide a
          sense of cost differences and an overall sense of cost feasibility for
          a large number of intersection and interchange forms. It is ultimately
          envishioned for VJuST, VJuST-C, and other analysis tools to be
          consolidated into a single, web-based tool.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <InfoTitle title="Purpose" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={classes.bodyText}>
          The VDOT Junction Screening Tool and this VJuST Cost Estimate Module
          is intended to aid transportation engineers and planners in Virginia
          with considering and screening innovative intersection and interchange
          configurations. Results are based on user inputs for lane
          configurations and key cost items that can reasonably be estimated
          prior to the development of concept drawings. Default unit costs and
          percentage costs are used to estimate the design and construction cost
          of innovative intersection and interchange configurations.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={classes.bodyText}>
          The results provided in the VJuST Cost Estimate Module are not meant
          to replace other cost estimates conducted at the later stages of a
          project. Conventional cost estimates developed from survey data and
          design plans should still be conducted as a project progresses through
          design. As such, theVJuST Cost Estimate Module is intended to provide
          information to users that will aid them in the planning, screening,
          and decision-making processes used to determine which innovative
          intersection and interchange configurations should move forward.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <InfoTitle title="Scoring System" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" sx={classes.bodyText}>
          The VJuST Cost Estimate Module provides the total cost (including
          design, right of way and utilities, and construction) of different
          innovative intersections and interchanges. It is the user's
          responsibility to decide how to apply and prioritize the results from
          this tool.
        </Typography>
      </Grid>
    </Grid>
  );
}
